import { TranslateService } from '@ngx-translate/core';

import { inject } from '../../app-injector';

export const translate = (item: string, prefix = ''): string => {
  const translationKey = `${prefix}${item}`;
  const translation = inject<TranslateService>(TranslateService).instant(translationKey);
  const translationAvailable = translation !== translationKey;
  return translationAvailable ? translation : item;
};
